import { ContentSection, FormSection, GallerySection, HomeSections, HomeType, ImageBackgroundSection, ImageTextSection, KuenstlerSection } from "@/types";
import { ContentSectionComponent } from "../ContentSections/ContentSection";
import { GallerySectionComponent } from "../ContentSections/GallerySection";
import { FormSectionComponent } from "../ContentSections/FormSection";
import { ImageTextSectionComponent } from "../ContentSections/ImageTextSection";
import { ImageBackgroundSectionComponent } from "../ContentSections/ImageBackgroundSection";
import { KuenstlerComponent } from "./Kuenstler";

function RenderSectionComponent({
	component,
	index,
	homeContent,
	renderQR,
}: {
	component: ContentSection | FormSection | GallerySection | ImageTextSection | ImageBackgroundSection | KuenstlerSection;
	index: number;
	homeContent: HomeType | null;
	renderQR: boolean;
}) {
	let element = null;
	switch (component.__component) {
		case "elements.content":
			element = <ContentSectionComponent content={component} evenOdd={false} />;
			break;
		case "elements.gallery":
			element = <GallerySectionComponent content={component} />;
			break;
		case "elements.form-section":
			element = <FormSectionComponent content={component} />;
			break;
		case "elements.image-text-section":
			return <ImageTextSectionComponent content={component} />;
			break;
		case "elements.image-background-section":
			return <ImageBackgroundSectionComponent content={component} index={index} homeContent={homeContent} renderQR={renderQR} />;
			break;
		case "object.kuenstler":
			return <KuenstlerComponent kuenstler={component.real_kuenstler} />;
			break;
	}
	return element;
}

export const HomeContentSections = ({ sections, homeContent, renderQR }: { sections: HomeSections; homeContent: HomeType | null; renderQR: boolean }) => {
	if (homeContent === null) {
		return <></>;
	}
	return sections.map((sectionComponent, index) => {
		return <RenderSectionComponent component={sectionComponent} key={sectionComponent.id} index={index} homeContent={homeContent} renderQR={renderQR} />;
	});
};
